import { attach, createEffect, createEvent, sample } from 'effector'

import { resetPlayPageState } from '@/entities/game'
import { portalProfileAPI } from '@/entities/profile/portal'
import { createHideFx } from '@/shared/ui/modal'

export const showFx = createEffect<void, string>()
export const hideFx = createHideFx(showFx)

export const switchAccountButtonClicked = createEvent()

const updateAccountInfoFx = attach({ effect: portalProfileAPI.me })

export const $interactionDisabled = updateAccountInfoFx.pending

sample({
    clock: switchAccountButtonClicked,
    target: [resetPlayPageState, updateAccountInfoFx],
})

sample({
    source: updateAccountInfoFx.finally,
    target: hideFx,
})
